import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import {
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../General/General';
import DatePicker from "react-multi-date-picker";
import moment from "moment-jalaali";
import "moment/locale/fa"; // for Persian localization
import { useNavigate } from "react-router-dom";
import CrudPageHeader from "../components/CrudPageHeader";
import DataTable from "../components/DataTable";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import CrudFormModal from "../components/CrudFormModal";

const Project = () => {
    //#region const
    const navigate = useNavigate();
    const [SelectedCategory, SetSelectedCategory] = useState(General.GuidEmpty());
    const [Categories, setCategories] = useState([]);
    const [Products, setProducts] = useState([]);
    const toaster = useToaster();
    const [ShowModal, setShowModal] = useState(false);
    const [Image, setImage] = useState();
    const [ImageName, setImageName] = useState("");
    const [Employer, setEmployer] = useState("");
    const [PrevImageName, setPrevImageName] = useState("");
    const [Title, setTitle] = useState("");
    const [Header, setHeader] = useState("");
    const [Description, setDescription] = useState("");
    const [CategoryId, setCategoryId] = useState(General.GuidEmpty());
    const [ShowDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDay, setSelectedDay] = useState(moment());
    const [ProjectState, setProjectState] = useState("0");
    const [Order,setOrder] = useState(0);
    const [ErrorMsg, setErrorMsg] = useState("");
    //#endregion
    //#region Handler

    const ImageCheck = (e) => {
        setImage(e.target.files[0]); // Set the file to Image state
        setImageName(e.target.files[0].name);
    }

    //#endregion
    //#region method
    const clearDependecies = () => {
        setCategoryId(General.GuidEmpty());
        setEmployer("");
        setProjectState("0");
        SetSelectedCategory(General.GuidEmpty());
        setTitle("");
        setHeader("");
        setDescription("");
        setImageName("");
        setPrevImageName("");
        //setImage(null);
    }
    const Delete = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/project/delete/' + CategoryId,
            method: "delete",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setErrorMsg("");
                    toaster.push(General.ShowMessage('success', 'عملیات حذف با موفقیت انجام شد'), 'topCenter');
                    GetProduct();
                    GetCategories();
                    setCategoryId(General.GuidEmpty());
                    setShowDeleteModal(false);
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetCategoryById = (Id) => {
        setCategoryId(Id);
        var RequestOption = {
            url: General.ApiRoot() + '/project/getById/' + Id,
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    const row = result.data && result.data[0];
                    if (row) {
                        setTitle(row.Title);
                        setHeader(row.Header);
                        setDescription(row.Content);
                        setPrevImageName(row.FileName);
                        setProjectState(row.State);
                        setEmployer(row.Employer);
                        SetSelectedCategory(row.CategoryId)
                        setOrder(row.Order);
                        setShowModal(true);
                    }
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetCategories = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/category/getAll',
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setCategories(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetProduct = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/project/getAll',
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setProducts(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }

    const AddNewProduct = () => {
        setShowModal(true);
    }
    const CheckValidation = () => {
        if (Title == "") {
            setErrorMsg('لطفا عنوان را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا عنوان را وارد کنید'), 'topCenter');
            return false;
        }
        else if (Description == "") {
            setErrorMsg('لطفا توضیحات را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا توضیحات را وارد کنید'), 'topCenter');
            return false;
        }
        else {
            return true;
        }
    }
    const Save = () => {
        if (CheckValidation()) {
            setErrorMsg("");
            const isNew = CategoryId === General.GuidEmpty();
            const formData = new FormData();
            formData.append('FormFile', Image ? Image : ""); // Ensure Image is correctly set
            formData.append('FileName', ImageName ? ImageName : "");
            formData.append('Title', Title);
            formData.append('Content', Description);
            formData.append('Id', CategoryId);
            formData.append('PrevFileName', PrevImageName ? PrevImageName : "");
            formData.append('Employer', Employer);
            formData.append('StartedTime', selectedDay.format("jYYYY/jMM/jDD"))
            formData.append('State', ProjectState);
            formData.append('CategoryId', SelectedCategory);
            formData.append('Order', Order);
            const requestOptions = {
                url: General.ApiRoot() + '/project/' + (isNew ? 'insert' : 'update'),
                method: "post",
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...General.AuthHeader(),
                },
            };

            trackPromise(
                axios(requestOptions)
                    .then(function (result) {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفق انجام شد'), 'topCenter');
                        GetProduct();
                        clearDependecies();
                        if (!isNew) {
                            setShowModal(false);
                        }
                    }).catch((error) => {
                        const msg = error?.response?.data?.message || 'عملیات با خطا مواجه شد';
                        setErrorMsg(msg);
                        toaster.push(General.ShowMessage('error', msg), 'topCenter');
                    })
            );
        }
    }
    //#endregion

    const columns = [
        {
            id: "index",
            header: () => <div className="text-right"> ردیف</div>,
            cell: ({ row }) => <div className="">{row.index + 1}</div>,
        },
        {
            id: "title",
            header: () => <div className="text-right">عنوان پروژه</div>,
            cell: ({ row }) => <div className="">{row.original.Title}</div>,
        },
        {
            id: "header",
            header: () => <div className="text-right">هدر</div>,
            cell: ({ row }) => <div className="">{row.original.Header}</div>,
        },
        {
            id: "order",
            header: () => <div className="text-right">ترتیب نمایش</div>,
            cell: ({ row }) => <div className="">{row.original.Order}</div>,
        },
        General.actionsColumn(GetCategoryById, (id) => (setCategoryId(id), setShowDeleteModal(true))),
    ];

    const table = useReactTable({
        data: Products,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    useEffect(() => {
        // Check if the user is authenticated
        if (!General.isLoggedIn()) {
            navigate('/'); // Redirect to login if not authenticated
        }
        else {
            GetCategories();
            GetProduct();
        }
    }, []);


    return (
        <SharedLayouts>
            <div className="bg-white h-screen w-full px-2">
                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")} className="mb-2">
                        {ErrorMsg}
                    </rsuite.Message>
                )}
                <CrudPageHeader title="پروژه" onAdd={AddNewProduct} />
                <DataTable table={table} />
            </div>
            <CrudFormModal
                open={ShowModal}
                title="تعریف پروژه جدید"
                onClose={() => (setShowModal(false), clearDependecies())}
                onSave={Save}
            >
                <rsuite.Row>
                    <label>تاریخ شروع پروژه</label>
                    <div className="mt-2">
                        <DatePicker
                            onChange={setSelectedDay}
                            value={selectedDay}
                            isGregorian={false} // To enable Jalali calendar
                            timePicker={false} // Disables the time picker
                            className="w-full border rounded-md h-9"
                        />
                    </div>
                </rsuite.Row>
                <rsuite.Row className="mt-2">
                    <rsuite.Col xs={12}>
                        <label>انتخاب محصول</label>
                        <rsuite.InputPicker
                            data={Categories}
                            valueKey="Id"
                            labelKey="Title"
                            value={SelectedCategory}
                            onChange={(e) => SetSelectedCategory(e)}
                            block
                            placeholder='انتخاب کنید'
                            className="mt-1"
                        />
                    </rsuite.Col>
                    <rsuite.Col xs={12}>
                        <label>ترتیب نمایش</label>
                        <rsuite.InputNumber value={Order} onChange={e => setOrder(e)} className="mt-1" />
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row className="mt-3">
                    <rsuite.Col xs={12}>
                        <label>عنوان پروژه</label>
                        <rsuite.Input value={Title} onChange={e => setTitle(e)} className="mt-1 mb-3" />
                    </rsuite.Col>
                    <rsuite.Col xs={12}>
                        <label>کارفرما</label>
                        <rsuite.Input value={Employer} onChange={e => setEmployer(e)} className="mt-1 mb-3" />
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row>
                    <rsuite.Col xs={24} className="mt-2">
                        <label>وضعیت پروژه</label>
                        <rsuite.RadioGroup name="rsuite.Radio-group-inline" inline defaultValue={ProjectState}>
                            <rsuite.Radio value="0" onChange={(e) => setProjectState(e)}>در حال شروع</rsuite.Radio>
                            <rsuite.Radio value="1" onChange={(e) => setProjectState(e)}>در دست اجرا</rsuite.Radio>
                            <rsuite.Radio value="2" onChange={(e) => setProjectState(e)}>اتمام قرارداد</rsuite.Radio>
                        </rsuite.RadioGroup>
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row className="mt-2">
                    <label>انتخاب عکس</label>
                    <rsuite.Input type="file" onInput={ImageCheck} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <label>توضیحات</label>
                    <rsuite.Input as="textarea" value={Description} onChange={e => setDescription(e)} rows={3} className="mt-1 mb-3" />
                </rsuite.Row>
            </CrudFormModal>

            <ConfirmDeleteModal
                open={ShowDeleteModal}
                message="آیا از حذف پروژه مطمئن هستید؟در صورت حذف قادر به بازیابی اطلاعات نخواهید بود."
                onConfirm={Delete}
                onCancel={() => (setShowDeleteModal(false), setCategoryId(General.GuidEmpty()))}
            />
        </SharedLayouts>
    )
}
export default Project;
